import { useMutation, useQuery, useQueryClient } from "react-query";

import * as models from "./models";
import * as service from "./services";

export function useDeployFlow() {
    const queryClient = useQueryClient();
    const mutation = useMutation(
        (flowInput: models.FlowInput) => {
            return service.deployFlow(flowInput);
        },
        { }
    );

    return mutation;
}